import { useSelector } from "react-redux";
import Sidebar from "../ui/sidebar/sidebar";
import styles from "./styles.module.scss";

const Layout = ({ children }) => {
  const { isAuth } = useSelector((state) => state.auth);
  const adminRole = localStorage.getItem("adminRole");
  return (
    <div className={styles.layout}>
      <Sidebar />
      <div className={`${isAuth && adminRole ? styles.children : styles.full_width}`}>
        {children}
      </div>
    </div>
  );
};

export default Layout;
